import { ILop } from "../../../model/respone/category/ILop";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eLopActionTypeDefine = {
    LOAD_START: {} as { truongId?: number, khoiId?: number, heId?: number } | undefined,
    LOAD_SUCCESS: {} as ILop[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as undefined | ILop,
    CLOSE_EDIT_MODAL: undefined,
    
    SAVE_START: {} as ILop,
    SAVE_SUCCESS: {} as ILop,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",
};

export const eLopActionTypeIds = generateActionTypeIds(eLopActionTypeDefine, "LOP");

export type ILopActions = IGenericActionType<typeof eLopActionTypeDefine, "LOP">;
